"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactCssTransitionReplace = _interopRequireDefault(require("react-css-transition-replace"));

var _svg = _interopRequireDefault(require("./svg"));

require("./carousel.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "move", function (index) {
      var newIndex = index;

      if (newIndex > _this.props.children.length - 1) {
        newIndex = 0; // Loop back to the start
      } else if (newIndex < 0) {
        newIndex = _this.props.children.length - 1; // Go to end
      }

      _this.setState({
        viewedIndex: newIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "moveBack", function () {
      _this.move(_this.state.viewedIndex - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "moveForward", function () {
      _this.move(_this.state.viewedIndex + 1);
    });

    _this.state = {
      viewedIndex: props.startIndex || 0
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var visibleChild = this.props.children[this.state.viewedIndex];
      var indicators = [];

      var _loop = function _loop(i) {
        var moveTo = function moveTo() {
          return _this2.move(i);
        };

        indicators.push( /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          key: i,
          onClick: moveTo,
          className: "circle clearButton ".concat(_this2.state.viewedIndex === i ? 'selected' : '')
        }));
      };

      for (var i = 0; i < this.props.children.length; i += 1) {
        _loop(i);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "Carousel"
      }, /*#__PURE__*/_react["default"].createElement(_reactCssTransitionReplace["default"], {
        transitionName: "fade-wait",
        transitionEnterTimeout: 1000,
        transitionLeaveTimeout: 600
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "slide-container",
        key: visibleChild.key
      }, visibleChild)), /*#__PURE__*/_react["default"].createElement(_svg["default"], {
        id: "chevron-light",
        className: "arrow back",
        onClick: this.moveBack
      }), /*#__PURE__*/_react["default"].createElement(_svg["default"], {
        id: "chevron-light",
        className: "arrow forward",
        onClick: this.moveForward
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "indicators"
      }, indicators));
    }
  }]);

  return Carousel;
}(_react.Component);

_defineProperty(Carousel, "propTypes", {
  children: _propTypes["default"].arrayOf(_propTypes["default"].node).isRequired,
  startIndex: _propTypes["default"].number
});

_defineProperty(Carousel, "defaultProps", {
  startIndex: 0
});

var _default = Carousel;
exports["default"] = _default;